// src/pages/HomeRedirector.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function HomeRedirector() {
  const navigate = useNavigate();
  useEffect(() => {
    const role = localStorage.getItem('userRole');
    const roleLower = role?.toLowerCase();

    // Débogage - voir ce qui est stocké
    console.log('=== HomeRedirector DEBUG ===');
    console.log('Rôle brut:', role);
    console.log('Rôle lower:', roleLower);
    console.log('Longueur rôle:', role?.length);
    console.log('Caractères:', role ? [...role].map(c => `${c}(${c.charCodeAt(0)})`) : 'N/A');

    if (roleLower === 'administrateur') {
      navigate('/admin/dashboard', { replace: true });
    } else if (roleLower === 'responsable') {
      navigate('/responsable/dashboard', { replace: true });
    } else if (roleLower === 'superviseur en chef') {
      navigate('/superviseur-en-chef/dashboard', { replace: true });
    } else if (roleLower === 'chef de zone') {
      navigate('/chef-zone/dashboard', { replace: true });
    } else if (roleLower === 'responsable hotesses') {
      navigate('/responsable-hotesses/presence', { replace: true });
    } else if (roleLower === 'geo_observateur') {
      navigate('/geo/geolocalisation', { replace: true });
    } else {
      // Par défaut, redirection vers chef de zone (anciennes données)
      console.warn('Rôle non reconnu, redirection par défaut vers Chef de Zone');
      navigate('/chef-zone/dashboard', { replace: true });
    }
  }, [navigate]);
  return <div>Chargement...</div>;
}
export default HomeRedirector;